module.exports = __webpack_public_path__ + "static/bimbo_eating_cookie-96578ae697c5c8144e2a43ae369adb15.png";